<template>
  <div class="h-full">
    <slot />
  </div>
</template>